<template>

<li v-if="adminView">
    <router-link :to="'/admin/articles/' + item.kb_item_id">{{ item.topic }}</router-link>
    <ul v-if="item.sub_menu && item.sub_menu.length > 0 && item.kb_category_id == getKBItem.kb_category_id">
        <nested-list-item v-for="(subMenuItem, index) in item.sub_menu" :item="subMenuItem" :adminView="true" :key="'kb-menu-item-' + subMenuItem.kb_item_id"></nested-list-item>
    </ul>
</li>

<li v-else>
    <router-link :to="'/help-center/articles/' + item.kb_item_id">{{ item.topic }}</router-link>
    <ul v-if="item.sub_menu && item.sub_menu.length > 0 && item.kb_category_id == getKBItem.kb_category_id">
        <nested-list-item v-for="(subMenuItem, index) in item.sub_menu" :item="subMenuItem" :adminView="false" :key="'kb-menu-item-' + subMenuItem.kb_item_id"></nested-list-item>
    </ul>
</li>

</template>

<script>
import { mapGetters } from "vuex"
export default {
    name: 'nested-list-item',
    props: [ 'item', 'adminView' ],
    data() {
        return {
            kbItems: [],
            kb_category_id: null
        }
    },
    computed: {
        ...mapGetters('dashboard_module', [
            'getKBItem'
        ])
    }
}
</script>

<style>

</style>
